import { render, staticRenderFns } from "./UserGroupControlManagement.vue?vue&type=template&id=987f8e10&"
import script from "./UserGroupControlManagement.vue?vue&type=script&lang=js&"
export * from "./UserGroupControlManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports